import { createSelector } from 'reselect'
import { DefaultRootState } from 'react-redux'
import { ShiftIssue } from './types'

// Stable identity so an unassessed shift does not re-render the banner on every store change.
const NO_ISSUES: ShiftIssue[] = []

const selectShiftIssuesState = (state: DefaultRootState) => state.shiftIssues
const selectShiftID = (_state: DefaultRootState, shiftID: number) => shiftID

export const selectShiftIssues = createSelector(
  [selectShiftIssuesState, selectShiftID],
  (shiftIssues, shiftID): ShiftIssue[] => shiftIssues?.entityMap[shiftID]?.issues ?? NO_ISSUES,
)
